function getPartScore(currentPart, partIndex, partScore) {
    return currentPart > partIndex ? partScore.toString() : "-";
}
export { getPartScore };
//# sourceMappingURL=GetPartScore.js.map